import { useState, useCallback } from 'react';

export type AlertType = 'success' | 'error' | 'info' | 'warning';

export interface InlineAlertState {
  type: AlertType;
  message: string;
  title?: string;
}

export const useInlineAlert = (autoDismissMs: number = 5000) => {
  const [alert, setAlert] = useState<InlineAlertState | null>(null);

  const showAlert = useCallback((type: AlertType, message: string, title?: string) => {
    setAlert({ type, message, title });
    if (autoDismissMs > 0) {
      setTimeout(() => setAlert(null), autoDismissMs);
    }
  }, [autoDismissMs]);

  const clearAlert = useCallback(() => {
    setAlert(null);
  }, []);

  const showSuccess = useCallback((message: string, title?: string) => {
    showAlert('success', message, title);
  }, [showAlert]);

  const showError = useCallback((message: string, title?: string) => {
    showAlert('error', message, title);
  }, [showAlert]);

  const showInfo = useCallback((message: string, title?: string) => {
    showAlert('info', message, title);
  }, [showAlert]);

  const showWarning = useCallback((message: string, title?: string) => {
    showAlert('warning', message, title);
  }, [showAlert]);

  return {
    alert,
    showAlert,
    clearAlert,
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
};
